import { createListSearch } from "./listSearch";
const fields = {
  client: ["RaisonSociale", "client.companyName"],
  numero: ["NumeroContrat", "IdContrat"],
  candidate: ["NomPrenom", "candidate.firstname", "candidate.lastname"],
};
export const createContractSearch = (query, criterion = "all") => createListSearch(query, criterion === "all" ? [...Object.values(fields).flat(), "DateDebut", "DateFin", "Qualification", "typeContrat", "statut"] : fields[criterion] || []);
export const matchesContractSearch = (contract, query, criterion = "all") => createContractSearch(query, criterion)(contract);
